import React from "react";
import { Check, Clock, Square, AlertCircle } from "lucide-react";
import { Badge } from "../ui/badge";

/**
 * Component for displaying pipeline status with appropriate badge styling
 */
const PipelineStatusBadge = ({ status, stage }) => {
  switch (status) {
    case "SUCCESSFUL":
      return (
        <Badge variant="success" className="flex items-center">
          <Check className="w-3 h-3 mr-1" /> Successful
        </Badge>
      );
    case "FAILED":
      return (
        <Badge variant="destructive" className="flex items-center">
          <AlertCircle className="w-3 h-3 mr-1" /> Failed
        </Badge>
      );
    case "STOPPED":
      return (
        <Badge variant="secondary" className="flex items-center">
          <Square className="w-3 h-3 mr-1" /> Stopped
        </Badge>
      );
    case "IN_PROGRESS":
      if (stage === "PAUSED") {
        return (
          <Badge variant="outline" className="flex items-center">
            <Clock className="w-3 h-3 mr-1" /> Paused
          </Badge>
        );
      }
      return (
        <Badge variant="outline" className="flex items-center">
          <Clock className="w-3 h-3 mr-1 animate-spin" /> Running
        </Badge>
      );
    case "PENDING":
      return (
        <Badge variant="outline" className="flex items-center">
          <Clock className="w-3 h-3 mr-1" /> Pending
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

export default PipelineStatusBadge;
